module.exports = __webpack_public_path__ + "static/media/equipment.ff99f4e8.png";